import { useAppContext } from "@kunduz/feature-website-context";
import React, { ReactElement } from "react";
import { useTranslation } from "next-i18next";
import { IContent } from "@kunduz/data-access-cms-api";
import { blue, gray, green } from "@kunduz/ui-components";
import { Infinity, LogOut01, User01 } from "@untitled-ui/icons-react";
import Link from "next/link";
import CoinIconActive from "@icons/coinIconActive.svg";
import { CmsDesktopNavItems } from "./cmsDesktopNavItems";
import { Avatar, Text } from "@kunduz/ui-atoms";
import styles from "./desktopRight.module.scss";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTriggerBase,
} from "@kunduz/ui-molecules";

export const DesktopRight = (props: {
  headerType: "student" | "teacher" | "school";
  desktopRightCmsData?: IContent.HeaderItemsResponse["components"];
}): ReactElement => {
  const { t } = useTranslation("kunduzcom_common");
  const { student, logout, kunduzApiToken, profiles } = useAppContext();

  const iconColors = {
    student: blue[600],
    teacher: green[600],
    school: blue[600],
  };

  const filteredDesktopCtaItems = props.desktopRightCmsData
    // ?.filter((x) => x.type == "headerbuttoncomponent")
    ?.filter((x) => {
      if (kunduzApiToken) return !x.data.hide_for_authenticated_user;
      else return !x.data.hide_for_unauthenticated_user;
    });

  async function handleLogoutClicked(e: any) {
    try {
      await logout();
    } catch (error) {
      return;
    } finally {
      window.location.reload();
    }
  }

  return (
    <div className={styles.wrapper}>
      <CmsDesktopNavItems
        iconColor={iconColors[props.headerType]}
        cmsData={filteredDesktopCtaItems}
      />

      {student?.data && (
        <div className={styles.coinIconWrapper}>
          <CoinIconActive width={20} height={20} />{" "}
          {student?.data?.limits?.questions?.is_unlimited ? (
            <Infinity viewBox="0 0 24 24" />
          ) : (
            student?.data?.limits?.questions?.remained
          )}
        </div>
      )}

      {student?.data && (
        <DropdownMenu>
          <DropdownMenuTriggerBase asChild>
            <Avatar
              text={
                student.data.first_name && student.data.last_name
                  ? `${student.data?.first_name[0]}${student.data?.last_name[0]}`
                  : undefined
              }
              placeholderIcon={User01}
            />
          </DropdownMenuTriggerBase>
          <DropdownMenuContent align="end" sideOffset={8}>
            <DropdownMenuItem asChild>
              <Link href={"/u/"} locale={false}>
                <User01 width={20} height={20} />
                <Text variant="textmd" weight="medium" color={gray[900]}>
                  {`${student.data.first_name} ${student.data.last_name}`}
                </Text>
              </Link>
            </DropdownMenuItem>

            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogoutClicked}>
              <LogOut01 width={20} height={20} />
              <Text variant="textmd" weight="medium" color={gray[900]}>
                {t("profile_logout_label")}
              </Text>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}

      {(profiles?.teacher || profiles?.school_staff || profiles?.parent) && (
        <DropdownMenu>
          <DropdownMenuTriggerBase asChild>
            <Avatar
              text={`${profiles.first_name} ${profiles.last_name}`}
              placeholderIcon={User01}
            />
          </DropdownMenuTriggerBase>
          <DropdownMenuContent align="end" sideOffset={8}>
            <DropdownMenuItem asChild>
              <Link href={"/u/"} locale={false}>
                <User01 width={20} height={20} />
                <Text variant="textmd" weight="medium" color={gray[900]}>
                  {`${profiles.first_name} ${profiles.last_name}`}
                </Text>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogoutClicked}>
              <LogOut01 width={20} height={20} />
              <Text variant="textmd" weight="medium" color={gray[900]}>
                {t("profile_logout_label")}
              </Text>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
};
